import { render, staticRenderFns } from "./popup-price-verify.vue?vue&type=template&id=38567ae2&scoped=true"
import script from "./popup-price-verify.vue?vue&type=script&lang=js"
export * from "./popup-price-verify.vue?vue&type=script&lang=js"
import style0 from "./popup-price-verify.vue?vue&type=style&index=0&id=38567ae2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38567ae2",
  null
  
)

export default component.exports